import { render, staticRenderFns } from "./SingleBottomBtn.vue?vue&type=template&id=0dd04c54&scoped=true&"
import script from "./SingleBottomBtn.vue?vue&type=script&lang=js&"
export * from "./SingleBottomBtn.vue?vue&type=script&lang=js&"
import style0 from "./SingleBottomBtn.vue?vue&type=style&index=0&id=0dd04c54&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd04c54",
  null
  
)

export default component.exports